import { useMemo } from 'react';
import { useWorkflow } from '../workflow/hooks';
import { hasAllResolutionsShipmentScope } from '../utils/reasonUtils';
import { getBaseItemId } from '../utils/itemKey';

/**
 * Hook to determine if the currently selected reason is a shipment scope reason
 */
export const useShipmentScopeReason = (itemId?: string, reasonId?: string) => {
  const { order } = useWorkflow();

  const selectedReason = useMemo(() => {
    if (!reasonId || !order?.items || !itemId) return null;
    // For compound item IDs, extract the base item ID to find the order item
    const baseItemId = getBaseItemId(itemId);
    const orderItem = order.items.find((oi) => oi.id === baseItemId);
    if (!orderItem?.reasons) return null;
    return orderItem.reasons.find((reason) => reason.code === reasonId) || null;
  }, [reasonId, order, itemId]);

  const isShipmentScopeReason = selectedReason
    ? hasAllResolutionsShipmentScope(selectedReason)
    : false;

  return { selectedReason, isShipmentScopeReason };
};
